import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import ImageWithFallback from '@/components/ImageWithFallback'

import { getUrlForResize } from '@/services/functions'
import { ASSET_PATHS } from '@/services/paths'

import * as S from './styles'

import type { RelatedUsersList } from '@/types/components/Modal/Templates/ShareCollection'

interface AccessManagementProps {
  usersList: RelatedUsersList
  onShowManagementView: () => void
}

export default function AccessManagement({
  usersList,
  onShowManagementView
}: AccessManagementProps) {
  const visibleUsers = useMemo(
    () => (usersList.length > 3 ? usersList.slice(0, 2) : usersList),
    [usersList]
  )

  const { t } = useTranslation()

  return (
    <S.AccessManagementContainer>
      <strong>{t('subtitles.usersWithAccess')}</strong>

      <S.AccessManagementContent>
        <ul>
          {visibleUsers.map(user => (
            <li key={user.email}>
              <ImageWithFallback
                fallbackSrc={ASSET_PATHS.default_avatar}
                width={40}
                title={user.email}
                height={40}
                src={getUrlForResize(
                  `users/images/${user.cognito_id}`,
                  40,
                  40,
                  'png'
                )}
                alt={user.email}
                autoSize={false}
              />
            </li>
          ))}
          {visibleUsers.length !== usersList.length && (
            <li>
              <div className="long-list-indicator">
                +{usersList.length - visibleUsers.length}
              </div>
            </li>
          )}
        </ul>

        <button id="manage-access-btn" onClick={onShowManagementView}>
          {t('buttons.manageAccess')}
        </button>
      </S.AccessManagementContent>
    </S.AccessManagementContainer>
  )
}
